import { FlexRow } from '@/components/common/Flex';
import { Paragraph } from '@/components/common/Typography';
import { Circle, Tooltip } from '@chakra-ui/react';
import { TransactionEntryTag } from '@common/react/cashflow';
import { sortBy } from '@common/util/arrays';

interface TagCirclesProps {
    tags: TransactionEntryTag[];
}

const TagCircles = ({ tags }: TagCirclesProps) => {
    if (tags.length === 0) return null;

    const label = sortBy(tags, 'name').map((tag) => (
        <FlexRow key={tag.name} gap={2} align="center" m={2}>
            <Circle size={2} bg={tag.color} />
            <Paragraph>{tag.name}</Paragraph>
        </FlexRow>
    ));

    return (
        <Tooltip label={label} aria-label="Tag names">
            <FlexRow w={5} flexWrap="wrap" gap={1}>
                {tags.map((tag) => (
                    <Circle
                        key={tag.name}
                        data-cy={`tag-circle-${tag.name}`}
                        size={2}
                        bg={tag.color}
                    />
                ))}
            </FlexRow>
        </Tooltip>
    );
};

export default TagCircles;
